import React, { forwardRef } from 'react'
import { usePaymentInputs } from 'react-payment-inputs'

import { TextInput, TextInputProps } from '../TextInput'

export interface CreditCardCvcInputProps extends TextInputProps {}

export const CreditCardCvcInput = forwardRef(({ ...restProps }: CreditCardCvcInputProps, ref) => {
  const { getCVCProps } = usePaymentInputs()

  return <TextInput {...getCVCProps()} label="CVC" ref={ref} {...restProps} />
})

export default CreditCardCvcInput
